
import Page from '@/Page.vue';
import { Component, Prop } from 'vue-property-decorator';
import { getAppVersion, getFormattedBuildDate } from '@/version';

import DashboardMainPanel from '@/libs/dashboard/components/DashboardMainPanel.vue';
import DashboardDonePlanItems from '@/libs/dashboard/components/DashboardDonePlanItems.vue';
import DashboardWaitingPlanItems from '@/libs/dashboard/components/DashboardWaitingPlanItems.vue';

import { Navigation } from 'swiper';
import { directive, Swiper, SwiperSlide } from 'vue-awesome-swiper';
import { authStore } from '@/libs/auth/+store/store';
import { AuthGetter } from '@/libs/auth/models/auth-state';
import { TenantUserModel, PermissionTypeEnum } from '@/libs/Api';
import DashboardCardView from '@/libs/dashboard/components/DashboardCardView.vue';
import DashboardTodayIssueSolving from '@/libs/dashboard/components/DashboardTodayIssueSolving.vue';
import DashboardTodayMaintenance from '@/libs/dashboard/components/DashboardTodayMaintenance.vue';
import DashboardTodayAudits from '@/libs/dashboard/components/DashboardTodayAudits.vue';
import DashboardFindings from '@/libs/dashboard/components/DashboardFindings.vue';
import DashboardMeasures from '@/libs/dashboard/components/DashboardMeasures.vue';
import DashboardMeasureVerification from '@/libs/dashboard/components/DashboardMeasureVerification.vue';
import DashboardPerformedAudits from '@/libs/dashboard/components/DashboardPerformedAudits.vue';
import DashboardNotPerformedAudits from '@/libs/dashboard/components/DashboardNotPerformedAudits.vue';
import DashboardQuickStats from '@/libs/dashboard/components/DashboardQuickStats.vue';

@Component({
    components: {
        DashboardQuickStats,
        DashboardNotPerformedAudits,
        DashboardPerformedAudits,
        DashboardMeasureVerification,
        DashboardMeasures,
        DashboardFindings,
        DashboardTodayAudits,
        DashboardTodayMaintenance,
        DashboardTodayIssueSolving,
        DashboardCardView,
        DashboardMainPanel,
        DashboardDonePlanItems,
        DashboardWaitingPlanItems,
        Swiper,
        SwiperSlide,
    },
    directives: {
        swiper: directive,
    },
})
export default class Dashboard extends Page {
    @Prop() tenantId!: string;

    tenantUser = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
    PermissionTypeEnum: typeof PermissionTypeEnum = PermissionTypeEnum;

    get swiperOptions(): any {
        return {
            modules: [Navigation],
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        };
    }

    get useTpm(): boolean {
        return (window as any).UseTpm ?? false;
    }

    get appVersion(): string {
        return getAppVersion();
    }

    get buildDate(): string {
        return getFormattedBuildDate(this.$i18n.locale);
    }
}
